import { useTranslation } from 'react-i18next'

// Translates with the projects namespace, as the revision screens do.
export const useProjectsT = () => {
  const { t } = useTranslation(['projects'])
  return (key: string, options?: object) => t(key, { ns: 'projects', ...options }) as string
}
